var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.212,
    height: 18.212,
    viewBox: "0 0 18.212 18.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_hierarchy",
    "data-name": "vuesax/bold/hierarchy",
    transform: "translate(-236 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hierarchy",
    transform: "translate(236 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H18.212V18.212H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.932,2.466A2.466,2.466,0,1,1,2.466,0,2.466,2.466,0,0,1,4.932,2.466Z",
    transform: "translate(1.518 1.518)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.553,2.276A2.276,2.276,0,1,1,2.276,0,2.276,2.276,0,0,1,4.553,2.276Z",
    transform: "translate(1.518 12.141)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.553,2.276A2.276,2.276,0,1,1,2.276,0,2.276,2.276,0,0,1,4.553,2.276Z",
    transform: "translate(12.141 12.141)",
    fill: "#1383d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M11.322,7.383A5.258,5.258,0,0,0,6.359,3.855H6.336l-2.679.008a2.573,2.573,0,0,1-2.5-1.889V.577A.578.578,0,0,0,.577,0,.572.572,0,0,0,0,.577V9.091a.576.576,0,0,0,.577.577.583.583,0,0,0,.584-.577V4.067a3.75,3.75,0,0,0,2.489.956h.015l2.679-.008h.015a4.087,4.087,0,0,1,3.862,2.747.593.593,0,0,0,.554.395.551.551,0,0,0,.19-.03A.584.584,0,0,0,11.322,7.383Z",
    transform: "translate(3.225 4.743)",
    fill: "#1383d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystm);
export default __webpack_public_path__ + "static/media/systm.8ff6d9c18a9705a7b76c90e6e7ee239b.svg";
export { ForwardRef as ReactComponent };